import React from 'react';
import CloseIcon from '@material-ui/icons/Close';

export default function CloseButton({ onClose }: { onClose: () => void }) {
    return (
        <CloseIcon
            style={{
                width: 30,
                height: 30,
                padding: 3,
                borderRadius: '50%',
                backgroundColor: 'white',
                boxShadow: '0px 3px 3px rgba(0,1,1,0.15)',
                border: '0.25px solid rgba(0,1,1,0.15)',
                cursor: 'pointer',
                marginRight: 4,
            }}
            onClick={onClose}
        />
    );
}
